import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Footer } from "@/components/Footer";
import { Wordmark } from "@/components/Header";

const Privacy = () => {
  useEffect(() => {
    document.title = "Privacy | Rust langs de A1";
    return () => {
      document.title = "Rust langs de A1 | Samen voor 80 km/u";
    };
  }, []);

  return (
    <div className="min-h-screen bg-gooi-offwhite">
      <header className="border-b border-gooi-green/10">
        <div className="mx-auto flex max-w-[90rem] items-center justify-between px-5 py-5 md:px-12">
          <Wordmark />
          <Link
            to="/"
            data-testid="privacy-back-link"
            className="inline-flex items-center gap-2 text-sm font-semibold text-gooi-green/80 transition-colors duration-300 hover:text-gooi-green"
          >
            <ArrowLeft className="h-4 w-4" strokeWidth={1.5} aria-hidden="true" />
            Terug naar de campagne
          </Link>
        </div>
      </header>
      <main data-testid="privacy-page" className="mx-auto max-w-3xl px-5 py-16 md:py-24">
        <h1 className="font-display text-4xl font-medium tracking-tight text-gooi-green md:text-5xl">Privacy</h1>
        <div className="mt-10 space-y-10 text-base leading-relaxed text-gooi-green/80">
          <section>
            <h2 className="font-display text-xl font-medium tracking-tight text-gooi-green md:text-2xl">
              Wie we zijn
            </h2>
            <p className="mt-3">
              Rust langs de A1 is een onafhankelijk burgerinitiatief dat zich inzet voor een structurele
              snelheidsverlaging naar 80 km/u op de A1 tussen Naarden/Bussum en knooppunt Eemnes. Deze website
              informeert bezoekers en verwijst naar de petitie op petities.nl.
            </p>
          </section>
          <section>
            <h2 className="font-display text-xl font-medium tracking-tight text-gooi-green md:text-2xl">
              Privacyvriendelijke statistieken
            </h2>
            <p className="mt-3">
              We meten hoe de website wordt gebruikt om de campagne te verbeteren. Daarbij geldt:
            </p>
            <ul className="mt-3 list-disc space-y-2 pl-5">
              <li>We plaatsen <strong>geen cookies</strong> en gebruiken geen trackers van derden.</li>
              <li>
                We registreren anonieme gebeurtenissen, zoals een paginabezoek, hoe ver er wordt gescrold en of op
                een knop naar de petitie wordt geklikt (inclusief de positie van die knop).
              </li>
              <li>
                We slaan daarbij alleen het apparaattype (mobiel of desktop), de verwijzende website en eventuele
                UTM-campagneparameters op. We bewaren geen IP-adressen en bouwen geen persoonsprofielen.
              </li>
            </ul>
          </section>
          <section>
            <h2 className="font-display text-xl font-medium tracking-tight text-gooi-green md:text-2xl">
              Contactformulier
            </h2>
            <p className="mt-3">
              Als je ons een bericht stuurt, verwerken we je naam, e-mailadres en bericht uitsluitend om je vraag
              te beantwoorden. We delen deze gegevens niet met derden en bewaren ze niet langer dan nodig. Wil je
              dat we je bericht verwijderen? Stuur ons dan een nieuw bericht via het contactformulier.
            </p>
          </section>
          <section>
            <h2 className="font-display text-xl font-medium tracking-tight text-gooi-green md:text-2xl">
              De petitie op petities.nl
            </h2>
            <p className="mt-3">
              De petitie zelf wordt gehost door petities.nl. Als je daar tekent, geldt het privacybeleid van
              petities.nl. Wij ontvangen of bewaren geen gegevens van ondertekenaars via deze website.
            </p>
          </section>
          <section>
            <h2 className="font-display text-xl font-medium tracking-tight text-gooi-green md:text-2xl">
              Vragen
            </h2>
            <p className="mt-3">
              Heb je een vraag over deze privacyverklaring? Neem contact op via het{" "}
              <Link
                to="/#contact"
                className="font-semibold text-gooi-green underline decoration-gooi-green/30 underline-offset-4 transition-colors duration-300 hover:decoration-gooi-green"
              >
                contactformulier
              </Link>
              .
            </p>
          </section>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Privacy;
